import { Component, OnInit } from '@angular/core';
import { AppStateService } from 'core/app-state/app-state.service';
import { AuthenticationService } from 'core/authentication/authentication.service';

declare global {
  interface Window {
    ipcRenderer: any;
  }
}

@Component({
  selector: 'app-no-internet-connection',
  templateUrl: './no-internet-connection.component.html',
  styleUrls: ['./no-internet-connection.component.scss'],
  standalone: false
})
export class NoInternetConnectionComponent implements OnInit {

  failedLocalServerRun = false;

  constructor(
    private authentificationService: AuthenticationService,
    private appStateService: AppStateService
  ) { }

  ngOnInit() {
    this.failedLocalServerRun = this.appStateService.state.localServerFailure;
  }

  retryConnectionToInternet() {
    if (this.failedLocalServerRun) {
      window.ipcRenderer.send('close-app');
      return;
    }
    if (this.appStateService.state.isInternetConnected) {
      this.authentificationService.authorize();
    }
  }

}
